import React, { useEffect, useState, useMemo } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import { FormControl, TextField } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import DataTable from 'react-data-table-component'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Dialog from '@material-ui/core/Dialog'
import CancelIcon from '@material-ui/icons/Cancel'
import { DialogContentText, DialogContent, DialogTitle, DialogActions } from '@material-ui/core'
//*antd
import Modal from 'antd/es/modal';
//*Toastify
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
//*Styles and Assets
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
//*Components
import { downloadCSV } from '../../common/Utils'
import TableFilterComponent from '../../common/TableFilterComponentTechnicians'
import { customStyleSecondary } from '../../common/CommonStyles'
import { Backdrop, CircularProgress } from '@material-ui/core'

const useStyles = makeStyles({
    stageButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    denyButton: {
        backgroundColor: "white"
    },
    cancelButton: {
        borderColor: "#7a9bc2"
    },
    deleteButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    pdfButton: {
        backgroundColor: "white"
    },
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    }
})

const TelematicsTechnicians = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const localclass = useStyles();
    const history = useHistory()
    const [filterText, setFilterText] = useState('')
    const [open, setOpen] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)

    const [deleteName, setDeleteName] = useState()
    const [deleteId, setDeleteId] = useState()

    const [oldName, setOldName] = useState()
    const [oldEmail, setOldEmail] = useState()
    const [oldPhone, setOldPhone] = useState()
    const [oldPhoneType, setOldPhoneType] = useState();
    const [oldPhoneTypeId, setOldPhoneTypeId] = useState();
    const [idTechnician, setIdTechnician] = useState([])

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const excelConfiguration = [
        {
            selector: 'name',
            label: t('telematicsInstallers.technicianName')
        },
        {
            selector: 'email',
            label: t('common.email')
        },
        {
            selector: 'phone',
            label: t('common.telephoneNumber')
        },
        {
            selector: 'phoneTypeDescription',
            label: t('telematicsInstallers.phoneType'),
        }
    ]

    const editTechnician = {
        "name": oldName,
        "email": oldEmail,
        "phone": oldPhone,
        "idPhoneType": oldPhoneTypeId
    }

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/CatalogInstaller/',
            linkLegend: t('telematicsInstallers.technicianCatalog'),
        }
        props.navigationActions.add_route(newRoute)
        props.actions.filter_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, filterText, onError, onSuccess)
        props.actions.fetch_Phone_Types(props.userLanguage, props.userToken, onError, onSuccess)
        return () => {

        }
    }, [filterText]) // eslint-disable-line react-hooks/exhaustive-deps

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    //*Delete Functions
    const handleOpenModalDelete = (row) => {
        setOpenDelete(true)
        setDeleteId(row.id)
        setDeleteName(row.name)
    }

    const handleCloseDelete = () => {
        setOpenDelete(false)
    }

    const handleDeleteTechnician = () => {
        handleOpenBackdrop()
        props.actions.delete_Technicians(props.userLanguage, props.userToken, deleteId, onError, onSuccessDelete)
    }

    const onSuccessDelete = () => {
        setOpenDelete(false)
        Modal.success({
            title: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.deleteSuccesfully')}</Typography>
        })
        props.actions.fetch_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, onError, onSuccess)
    }

    //*Update Functions
    const handleOpenModal = (row) => {
        setOpen(true)
        setOldName(row.name)
        setOldEmail(row.email)
        setOldPhone(row.phone)
        setOldPhoneTypeId(row.idPhoneType)
        setOldPhoneType(row.phoneTypeDescription)
        setIdTechnician(row.id)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const saveUpdate = () => {
        if (oldName !== undefined && oldEmail !== undefined && oldPhone !== undefined && oldPhoneType !== undefined) {
            props.actions.update_Technicians(props.userLanguage, props.userToken, idTechnician, editTechnician, onErrorUpdate, onSuccessUpdate)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const onSuccessUpdate = () => {
        setOpen(false)
        Modal.success({
            title: t('commonMessages.updatedSucc')
        })
        props.actions.fetch_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, onError, onSuccess)
    }

    //*Funtions Error & Navigation
    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    const onErrorUpdate = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    toast.error(t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`), { className: classes.toastSuccess })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    const technicianColumns = [
        {
            name: t('telematicsInstallers.technicianName'),
            selector: 'name',
            sortable: true,
            cell: row => row.name
        },
        {
            name: t('common.telephoneNumber'),
            selector: 'phone',
            width: '250px',
            sortable: true,
            cell: row => row.phone
        },
        {
            name: t('common.email'),
            selector: 'email',
            sortable: true,
            cell: row => row.email
        },
        {
            name: "",
            center: true,
            width: '150px',
            cell: row => (buttonForColumns(row))
        },
        {
            center: true,
            omit: true,
            cell: row => row.supplierServiceID
        }
    ]

    const buttonForColumns = (row) => {
        return (
            <div>
                <Tooltip title={t('common.edit')}>
                    <IconButton onClick={() => handleOpenModal(row)}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={t('common.delete')}>
                    <IconButton onClick={() => handleOpenModalDelete(row)}>
                        <DeleteForeverIcon />
                    </IconButton>
                </Tooltip>
            </div>
        )
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            handleOpenBackdrop()
            setFilterText('')
            props.actions.fetch_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, onError, onSuccess)
        }

        return <TableFilterComponent
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear} filterText={filterText}
            onExport={() => downloadCSV(props.technicianList, excelConfiguration)}
        />;
    }, [filterText, props]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Container className={classes.generalBorder}>
            <Backdrop className={classes.backdrop} open={openBackdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid item xs={12}><br /></Grid>
            <Grid>
                <DataTable
                    columns={technicianColumns}
                    defaultSortField="name"
                    customStyles={customStyleSecondary}
                    data={props.technicianList}
                    highlightOnHover
                    pointerOnHover
                    dense
                    responsive
                    striped
                    noHeader
                    pagination
                    paginationComponentOptions={paginationOptions}
                    subHeader
                    subHeaderComponent={subHeaderComponentMemo}
                    noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                />
                {
                    props.technicianList && props.technicianList.length < 1 && (
                        <Grid container item xs={12}><br /></Grid>
                    )
                }
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <Card >
                    <CardContent>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start"
                        >
                            <Grid item xs={11}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsInstallers.technicianName')}</Typography>
                                <TextField value={oldName} onChange={e => setOldName(e.target.value)} variant="outlined" size="small" fullWidth />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardContent>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start" >
                            <Grid item xs={11}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.email')}</Typography>
                                <TextField value={oldEmail} onChange={e => setOldEmail(e.target.value)} variant="outlined" size="small" fullWidth />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardContent>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start" >
                            <Grid item xs={11}>
                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.telephoneNumber')}</Typography>
                                <TextField
                                    type="tel"
                                    min="0"
                                    value={oldPhone}
                                    error={oldPhone < 0}
                                    onChange={e => setOldPhone(e.target.value)}
                                    helperText={oldPhone < 0 ? t('commonMessages.noLess') : ''}
                                    inputProps={{
                                        pattern: "[0-9]"
                                    }}
                                    variant="outlined" size="small" fullWidth />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <CardContent>
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start" >
                            <Grid item xs={11}>
                                <FormControl fullWidth={true}>
                                    <Autocomplete
                                        disableClearable={true}
                                        onChange={(event, newValue) => {
                                            setOldPhoneTypeId(newValue.id)
                                            setOldPhoneType(newValue.description);
                                        }}
                                        size="small"
                                        defaultValue={{ id: oldPhoneTypeId, description: oldPhoneType }}
                                        style={{ width: 500 }}
                                        options={props.phoneTypeList}
                                        getOptionLabel={(option) => option.description}
                                        getOptionSelected={(option, value) => option.description === value.description}
                                        renderInput={(params) => <TextField {...params} style={{ width: 453 }} label={t('telematicsInstallers.phoneType')} variant="outlined" />}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <br />
                        <Grid
                            container
                            direction="row"
                            justify="space-between"
                            alignItems="flex-start" >
                            <Grid item xs><br /></Grid>
                            <Grid item xs>
                                <Button onClick={saveUpdate} variant="contained" className={localclass.stageButton}>{t('common.save')}</Button>
                            </Grid>
                            <Grid item xs><br /></Grid>
                        </Grid>
                    </CardContent>
                    <ToastContainer />
                </Card>
            </Dialog>
            <Dialog open={openDelete} onClose={handleCloseDelete}>
                <DialogTitle> <CancelIcon fontSize="large" style={{ color: '#BF2E2E' }} /> {t('telematicsInstallers.warningDelete')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('telematicsInstallers.technician')}: {deleteName} </DialogContentText>
                    <DialogContentText>ID: {deleteId}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDelete} variant="outlined" className={localclass.cancelButton}>{t('common.cancel')}</Button>
                    <Button onClick={handleDeleteTechnician} variant="contained" className={localclass.deleteButton}>{t('common.delete')}</Button>
                </DialogActions>

            </Dialog>
            <Grid item xs={12}><br /></Grid>
        </Container>
    )
}

const mapStateToProps = state => ({
    technicianList: state.TelematicsReducer.technicianList,
    phoneTypeList: state.TelematicsReducer.phoneTypesList,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsTechnicians))